baseApp.directive('datePickerWithIndication', function () {
    return {
        templateUrl: '/public/directives/datePickerWithIndication.html',
        replace: false,
        scope: {
            service : '=',
            options: '=?',
            utc: '@?'
        },
        controller:  ['$scope', 'TimeZoneService', function($scope, TimeZoneService) {

            var serviceExpiration = angular.copy($scope.service.getExpiration());

            if($scope.utc) {
                serviceExpiration = TimeZoneService.convertFromTo(serviceExpiration, 'UTC', TimeZoneService.getCurrentTimeZone());
            }

            $scope.expiration = serviceExpiration;
            $scope.serviceExpireIn = calcExpirationTime(new Date($scope.expiration));

            function calcExpirationTime(expDate) {
                var willExpireStr = 'Expires in <time>';
                var expiredStr = 'Expired <time> ago';

                if (!expDate) {
                    return null;
                }

                var nowDate = new Date();

                var result = willExpireStr;
                if (expDate < nowDate)
                    result = expiredStr;

                return result.replace("<time>", moment.duration(expDate.getTime() - nowDate.getTime()).humanize());
            };

            $scope.$watch('expiration', function(newValue, oldValue) {
                if (newValue) {
                    if(newValue != oldValue){
                        var result = newValue;
                        if($scope.utc) {
                            result = TimeZoneService.convertFromTo(newValue, TimeZoneService.getCurrentTimeZone(), 'UTC');
                        }
                        $scope.serviceExpireIn = calcExpirationTime(new Date(result));
                        $scope.service.setExpiration(result);
                    }
                }
            }, true);

        }],
    }
});
